import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/shared";
import { CorporateDocuments } from "@/components/onboarding/CorporateDocuments";
import { Certifications } from "@/components/company/Certifications";
import { PoliciesPanel } from "@/components/policies/PoliciesPanel";
import { CompanyDetails } from "@/components/onboarding/CompanyDetails";
import { BankAccounts } from "@/components/onboarding/BankAccounts";

export default function MarksManDocuments() {
  const { user } = useAuth();
  const canEdit = ["owner", "admin", "pm", "finance"].includes(user?.role);
  const canReveal = ["owner", "admin", "finance"].includes(user?.role);
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "corporate";
  return (
    <div data-testid="marksman-documents-page">
      <PageHeader title="MarksMan Documents" subtitle="Our own company records — corporate documents, certifications, company & bank details and policies. Client agreements and project files are kept elsewhere." />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="bg-white border border-slate-200 h-auto p-1 mb-2">
          <TabsTrigger value="corporate" data-testid="tab-corporate">Corporate Documents</TabsTrigger>
          <TabsTrigger value="certifications" data-testid="tab-certifications">Certifications</TabsTrigger>
          {canEdit && <TabsTrigger value="company" data-testid="tab-company">Company & Bank Details</TabsTrigger>}
          <TabsTrigger value="policies" data-testid="tab-policies">Policies</TabsTrigger>
        </TabsList>
        <p className="text-xs text-slate-500 mb-5" data-testid="tab-explainer">
          {tab === "corporate" && "Reusable company records — PAN, GST, MSME / Udyam, TDS certificates, incorporation, bank letters / cancelled cheques, company profile and templates. Uploaded once and linked to any client request."}
          {tab === "certifications" && "ISO and other certifications with certificate numbers, certification body, validity and renewal history."}
          {tab === "company" && "Our legal entity, registration numbers and bank account details, kept in one place so they can be copied into client forms accurately."}
          {tab === "policies" && "Company policy library — current versions shown by default; earlier versions stay in history."}
        </p>
        <TabsContent value="corporate"><CorporateDocuments /></TabsContent>
        <TabsContent value="certifications"><Certifications /></TabsContent>
        {canEdit && <TabsContent value="company" className="space-y-5"><CompanyDetails canEdit={canEdit} canReveal={canReveal} /><BankAccounts canEdit={canEdit} /></TabsContent>}
        <TabsContent value="policies"><PoliciesPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
